import { START_LOCATION } from 'vue-router';
import type { RouterConfig } from '@nuxt/schema';

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        el: to.hash,
        top: 0,
        behavior: 'smooth',
      };
    }

    // On initial page load (or refresh):
    // - On reload without active user scrolling, always return to top.
    // - If the user has actively scrolled while the page was loading, maintain their current scroll position.
    if (from === START_LOCATION) {
      const isReload = typeof window !== 'undefined' && (
        (performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming)?.type === 'reload' ||
        (performance as any)?.navigation?.type === 1
      );

      const hasActivelyScrolled = typeof window !== 'undefined' && Boolean((window as any).__userHasActivelyScrolled);

      if (isReload && !hasActivelyScrolled) {
        return { left: 0, top: 0 };
      }

      if (hasActivelyScrolled && typeof window !== 'undefined' && window.scrollY > 0) {
        return false;
      }

      return { left: 0, top: 0 };
    }

    // If navigating to the same path (e.g. query changes without hash), keep position
    if (to.path.replace(/\/$/, '') === from.path.replace(/\/$/, '')) {
      return false;
    }

    // Page-to-page navigation resets to top
    return { left: 0, top: 0 };
  },
};

